export default __webpack_public_path__ + "static/media/100000.e488e9c0.jpg";